import { gql } from '@apollo/client'

import { INGREDIENT_KEYWORD_NODE_FRAGMENT } from '../fragments'

const INGREDIENT_KEYWORDS_QUERY = gql`
  query ingredientKeywords($ingredientId: ID!) {
    ingredientKeywords(ingredientId: $ingredientId) {
      uncategorized {
        ...IngredientKeywordNode
        children {
          ...IngredientKeywordNode
          children {
            ...IngredientKeywordNode
            children {
              ...IngredientKeywordNode
            }
          }
        }
      }

      synonyms {
        ...IngredientKeywordNode
        children {
          ...IngredientKeywordNode
          children {
            ...IngredientKeywordNode
            children {
              ...IngredientKeywordNode
            }
          }
        }
      }

      varieties {
        ...IngredientKeywordNode
        children {
          ...IngredientKeywordNode
          children {
            ...IngredientKeywordNode
            children {
              ...IngredientKeywordNode
            }
          }
        }
      }

      discarded {
        ...IngredientKeywordNode
        children {
          ...IngredientKeywordNode
          children {
            ...IngredientKeywordNode
            children {
              ...IngredientKeywordNode
            }
          }
        }
      }
    }
  }
  ${INGREDIENT_KEYWORD_NODE_FRAGMENT}
`

export default INGREDIENT_KEYWORDS_QUERY
